import React, { Component } from 'react'
import { Form, Input, Button, Alert } from 'antd'

function hasErrors (fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field])
}

class ResetForm extends Component {
  state = {
    success: false,
    error: {
      status: false,
      message: null
    }
  }

  componentDidMount () {
    this.props.form.validateFields()
  }

  setError = (payload) => {
    this.setState({
      error: payload
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { id } = this.props.organization.data

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setError({
          status: false,
          message: null
        })
        this.props.resetPassword(values.email, id).then((response) => {
          if (response.data.error && !response.data.result) {
            this.handleReset()
            this.props.form.validateFields()
            this.setError({
              status: true,
              message: response.data.error.message
            })
          }

          if (!response.data.error && !response.data.result) {
            this.handleReset()
            this.setState({
              success: true
            })
          }
        })
      }
    })
  }

  handleReset = () => {
    this.props.form.resetFields()
  }

  render () {
    const { error, success } = this.state
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form

    const emailError = isFieldTouched('email') && getFieldError('email')

    return (
      success
        ? <Alert type='success' message='Email with instructions on how to restore your password is sent to specified email.' />
        : <Form onSubmit={this.handleSubmit} className='form'>
          { error.status ? <div className='form__error'>{ error.message }</div> : null }
          <Form.Item validateStatus={emailError ? 'error' : ''} help={emailError || ''}>
            { getFieldDecorator('email', {
              rules: [{ required: true,
                message: 'Please input your email',
                max: 320,
                pattern: /^\S+@\S+\.\S+$/
              }]
            })(
              <Input placeholder='Email' name='email' maxLength={320} />
            )}
          </Form.Item>
          <Form.Item>
            <Button type='indigo' htmlType='submit' className='login__button' disabled={hasErrors(getFieldsError())}>Reset Password</Button>
          </Form.Item>
        </Form>
    )
  }
}

export default Form.create()(ResetForm)



// WEBPACK FOOTER //
// ./src/views/Reset/components/ResetForm/ResetForm.jsx